/* eslint-disable */
<template>
  <div class="page" v-if="!isReport">
    <div class="container">
      <div class="header">
        <img
          class="back"
          @click="handleBackClick"
          src="@/assets/quick/back.png"
          alt=""
        />
      </div>
      <div class="content">
        <div class="ip-layout">
          <img class="ip-icon" :src="currentFrameSrc" alt="" />
        </div>
        <div
          :class="[
            'word-content-wrap',
            { active: !isStart || !isCountdownEnd },
          ]"
        >
          <div class="word-content-border">
            <div class="word-content">
              <!-- 未开始 -->
              <div class="word-content-start" v-if="!isStart">
                <div class="child">
                  <img class="l" src="@/assets/quick/l.png" alt="" />
                  单词快问快答
                  <img class="r" src="@/assets/quick/r.png" alt="" />
                </div>
                <div class="round">第{{ roundNum }}轮</div>
                <div class="start-btn" @click="start">{{loading?"加载中...":"开始"}}
                </div>
              </div>
              <!-- 倒计时完就开始 -->
              <div v-else-if="!isCountdownEnd" class="countdown-content">
                <img
                  v-if="countdownTime === 1"
                  src="@/assets/quick/1.png"
                  alt=""
                />
                <img
                  v-else-if="countdownTime === 2"
                  src="@/assets/quick/2.png"
                  alt=""
                />
                <img
                  v-if="countdownTime === 3"
                  src="@/assets/quick/3.png"
                  alt=""
                />
              </div>
              <!-- 已开始 -->
              <div v-if="isCountdownEnd && isStart" class="word-picker-wrap">
                <div class="haader">
                  <div class="left">
                    <span>单词快问快答</span>
                    <!-- 进度条 -->
                    <div class="progress-bar-container">
                      <div class="progress-bar">
                        <div
                          class="progress"
                          :style="{ width: progressWidth + '%' }"
                        ></div>
                        <div
                          class="progress-dot"
                          :style="{ left: progressWidth + '%' }"
                        ></div>
                      </div>
                    </div>
                    <div class="word-num">
                      第<span>{{ currentWordIndex + 1 }}</span
                      >个，<span>共{{ wordList.length }}个</span>
                    </div>
                  </div>
                  <div class="right">
                    <img src="@/assets/quick/time.png" alt="" />
                    {{ answerCountdownTime }}s
                  </div>
                </div>
                <Picker
                  ref="myPicker"
                  :loading="loading"
                  v-model="pckerIndex"
                  :show-toolbar="false"
                  :columns="wordList"
                  @change="handleChange"
                  class="custom-word-picker"
                  :option-height="117"
                  :visible-option-num="3"
                  :columns-field-names="{ text: 'name', value: 'wordId' }"
                >
                  <template #option="option">
                    <div
                      :class="[
                        'custom-picker-item',
                        { active: option?.wordId === selectedWord?.wordId },
                      ]"
                    >
                      <div class="word-en">
                        {{ option.name }}
                        <span class="translate">{{
                          option?.contents?.[0]
                        }}</span>
                      </div>
                      <div class="word-phoneticSymbols" style="display: none">
                        {{ option?.wordInfo?.phoneticSymbols }}
                        <div :class="{ play: isPlaying }">
                          <img
                            class="horn"
                            @click="playAudio('topic')"
                            src="@/assets/quick/horn.png"
                            alt=""
                          />
                          <img
                            v-if="isPlaying"
                            class="play-1"
                            src="@/assets/quick/p-1.png"
                            alt=""
                          />
                          <img
                            v-if="isPlaying"
                            class="play-2"
                            src="@/assets/quick/p-2.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        v-if="
                          option?.isAnswer &&
                          option?.wordId === selectedWord?.wordId
                        "
                        :class="[
                          'is-right-box',
                          {
                            right: option.isRight === 'right',
                            error: ['error', 'timeout'].includes(
                              option.isRight
                            ),
                          },
                        ]"
                      >
                        {{
                          option.isRight === "right" ? "判断正确" : "判断错误"
                        }},答案：
                        <div class="word-translate">
                          {{ option?.wordInfo?.translate }}
                        </div>
                      </div>
                    </div>
                    <div>
                      <img
                        class="is-right"
                        v-if="option.isRight === 'right' && option?.isAnswer"
                        src="@/assets/quick/right.png"
                        alt=""
                      />
                      <img
                        class="is-right"
                        v-if="
                          (option.isRight === 'error' ||option.isRight === 'timeout') && option?.isAnswer
                        "
                        src="@/assets/quick/error.png"
                        alt=""
                      />
                    </div>
                  </template>
                </Picker>
                <div class="word-btns-wrap">
                  <div
                    class="word-btn"
                    v-if="!showBtnImg && !isAnswerCountdownEnd && wordList && wordList.length > 0"
                  >
                    <div
                      :class="[
                        'word-btn-item',
                        { error: curBtnType === 'error' },
                      ]"
                      @click="handleBtntClick('0')"
                    >
                      错误
                    </div>
                    <div
                      :class="[
                        'word-btn-item',
                        { right: curBtnType === 'right' },
                      ]"
                      @click="handleBtntClick('1')"
                    >
                      正确
                    </div>
                  </div>
                  <img
                    v-if="
                      showBtnImg &&
                      curBtnType === 'right' &&
                      !isAnswerCountdownEnd
                    "
                    class="btn-img"
                    src="@/assets/quick/b-right.png"
                    alt=""
                  />
                  <img
                    v-if="
                      showBtnImg &&
                      curBtnType === 'error' &&
                      !isAnswerCountdownEnd
                    "
                    class="btn-img"
                    src="@/assets/quick/wrong.png"
                    alt=""
                  />
                  <img
                    v-if="isAnswerCountdownEnd && curBtnType === 'timeout'"
                    class="btn-img"
                    src="@/assets/quick/timeout.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audio ref="audioRef" preload="auto"></audio>
  </div>
</template>
<script>
export default {
  name: "QuickQA",
};
</script>
<script setup>
import {
  ref,
  onMounted,
  nextTick,
  watch,
  computed,
  onBeforeUnmount,
} from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import {
  getFirstRoundWords,
  saveFirstRoundWordMeaning,
  getSecondRoundWords,
  saveSecondRoundWordMeaning,
  getThirdRoundWords,
  saveThirdRoundWordMeaning,
} from "@/api/quick";
/* eslint-disable-next-line */
import { Picker } from "vant";
// 引入本地音频
import audioOne from "@/assets/audio/one.mp3";
import audioTwo from "@/assets/audio/two.mp3";
import audioThree from "@/assets/audio/third.mp3";
import audioRight from "@/assets/audio/right.mp3";
import audioError from "@/assets/audio/error.mp3";
/* eslint-disable-next-line */
import audioChange from "@/assets/audio/change.mp3";
// 引入倒计时音频
import countdownOne from "@/assets/321begin/one.mp3";
import countdownTwo from "@/assets/321begin/two.mp3";
import countdownThree from "@/assets/321begin/three.mp3";
// 导入所有人物动画帧图片
const peopleFramesContext = require.context(
  "@/assets/people",
  false,
  /全身_\d+\.png$/
);
const peopleFrames = peopleFramesContext
  .keys()
  .sort((a, b) => {
    // 提取数字并排序
    const numA = parseInt(a.match(/\d+/)[0]);
    const numB = parseInt(b.match(/\d+/)[0]);
    return numA - numB;
  })
  .map((key) => peopleFramesContext(key));
const router = useRouter();
const route = useRoute();
const wordList = ref([]);
const isStart = ref(false);
// 开始时的倒计时是否完毕
const isCountdownEnd = ref(false);
const countdownTime = ref(3); // 倒计时时间
let timer = null;
// 倒计时音频引用
const countdownAudioRef = ref(null);
// 播放倒计时音频
function playCountdownAudio(num) {
  if (!countdownAudioRef.value) {
    // 创建倒计时音频元素
    countdownAudioRef.value = new Audio();
  }

  let audioSrc = null;
  if (num === 3) {
    audioSrc = countdownThree;
  } else if (num === 2) {
    audioSrc = countdownTwo;
  } else if (num === 1) {
    audioSrc = countdownOne;
  }

  if (audioSrc && countdownAudioRef.value) {
    // 停止之前的播放
    countdownAudioRef.value.pause();
    countdownAudioRef.value.currentTime = 0;
    // 设置新的音频源并播放
    countdownAudioRef.value.src = audioSrc;
    countdownAudioRef.value.play().catch((err) => {
      console.error("播放倒计时音频失败:", err);
    });
  }
}
function start() {
  if(loading.value) return
  isStart.value = true;
  // 关闭所有音频（包括人物语音和页面音频）
  closeAllAudio();
  // 确保倒计时音频也被停止（如果之前有播放）
  if (countdownAudioRef.value) {
    countdownAudioRef.value.pause();
    countdownAudioRef.value.currentTime = 0;
  }
  // 重置音频播放标志，防止任何待播放的音频继续
  shouldPlayAudio = false;
  // 稍等一下确保音频完全停止后再播放倒计时音频
  setTimeout(() => {
    // 立即播放倒计时3的音频
    playCountdownAudio(3);
  }, 50);
  // 立即把 3 显示出来，然后 1s → 2，再过 1s → 1，再过 1s 结束
  timer = setInterval(() => {
    if (countdownTime.value > 1) {
      countdownTime.value -= 1;
      // 播放对应数字的倒计时音频
      playCountdownAudio(countdownTime.value);
    } else {
      // 1→0 的瞬间立刻切状态并清掉定时器，不再多等 1s
      clearInterval(timer);
      countdownTime.value = 0;
      isCountdownEnd.value = true;
      // 初始化第一个单词
      nextTick(() => {
        pckerIndex.value = [wordList.value[0]?.wordId];
        changePickerValue(wordList.value[0]);
      });
    }
  }, 1000);
}
// 开始倒计时结束后，答题的倒计时
const answerCountdownTime = ref(0); // 答题倒计时时间
// 答题倒计时是否完毕
const isAnswerCountdownEnd = ref(false);
// 答题倒计时定时器
let answerCountdownTimer = null;
function startAnswerCountdown() {
  // 立即把 60 显示出来，然后 1s → 59，再过 1s → 58，再过 1s 结束
  clearInterval(answerCountdownTimer);
  answerCountdownTimer = setInterval(() => {
    if (answerCountdownTime.value > 1) {
      answerCountdownTime.value -= 1;
    } else {
      // 1→0 的瞬间立刻切状态并清掉定时器，不再多等 1s
      clearInterval(answerCountdownTimer);
      answerCountdownTime.value = 0;
      isAnswerCountdownEnd.value = true;
      // 更新当前答题状态
      selectedWord.value.isAnswer = true;
      selectedWord.value.isRight = "timeout";
      curBtnType.value = "timeout";
      // 更新音频
      pageAudioUrl.value = audioError;
      playAudio("page");
      // 进度交互
      setTimeout(() => {
        goNext();
      }, 800);
    }
  }, 1000);
}
// 进度条数据
const progressWidth = ref(0); // 初始进度30%
const currentWordIndex = ref(0); // 当前单词索引
const selectedWord = ref({});
function handleChange(e) {
  // 标记正在滚动
  isScrolling.value = true;
  setTimeout(() => {
    isScrolling.value = false;
  }, 1000); // 1秒后允许滚动
  changePickerValue(e.selectedOptions[0]);
}
// 切换picker 选中项
function changePickerValue(row,type) {
  const newWord = row;
  const oldWordId = selectedWord.value?.wordId;
  // 只有在切换单词时才停止之前的音频
  if (oldWordId && oldWordId !== newWord.wordId && audioRef.value) {
    audioRef.value.pause();
    isPlaying.value = false;
    // 停止动画
    stopFrameAnimation();
  }
  selectedWord.value = newWord;
  // 统一重置状态
  curBtnType.value = "";
  showBtnImg.value = false;
  isAnswerCountdownEnd.value = false;
  clearInterval(answerCountdownTimer);
  // 如果已答过题，恢复对应状态
  if (newWord?.isAnswer) {
    curBtnType.value = newWord.isRight;
    isAnswerCountdownEnd.value = newWord.isRight === "timeout";
    showBtnImg.value = true;
  } else {
    // 重置倒计时
    answerCountdownTime.value = newWord?.answerTime;
    // 同时开始答题倒计时
    startAnswerCountdown();
    // 切换单词时自动播放新单词的音频
    nextTick(() => {
      if (newWord?.wordInfo?.audioUrl && audioRef.value) {
        playAudio("topic");
      }
    });
  }
}
const curBtnType = ref("");
const showBtnImg = ref(false);
const pckerIndex = ref([]);
const myPicker = ref(null);
// Picker 滚动状态
const isScrolling = ref(false);
function handleBtntClick(type) {
  // 先把按钮状态写死，防止重复点击
  if (curBtnType.value || isSubmitting.value) return;
  curBtnType.value = type; // right / error
  showBtnImg.value = true; // 立即展示按钮图
  selectedWord.value.isAnswer = true;
  const isRight = type === selectedWord.value.correct.toString();
  // 设置音频
  pageAudioUrl.value = isRight ? audioRight : audioError;
  nextTick(() => {
    playAudio("page");
  });
  selectedWord.value.isRight = isRight ? "right" : "error";
  selectedWord.value.userAnswer = type;
  // 停止本题倒计时
  clearInterval(answerCountdownTimer);
  isAnswerCountdownEnd.value = false;

  // 800ms 后切到下一题
  setTimeout(() => {
    goNext();
  }, 800);
}
// 统一封装：更新进度、切下一题、检查是否全部答完
function goNext() {
  // 标记正在滚动
  isScrolling.value = true;
  setTimeout(() => {
    isScrolling.value = false;
  }, 1000); // 1秒后允许滚动

  // 更新进度条
  progressWidth.value =
    ((currentWordIndex.value + 1) / wordList.value.length) * 100;

  // 还有下一题
  if (currentWordIndex.value < wordList.value.length - 1) {
    currentWordIndex.value += 1;
  }
  // 找到未答题的索引3
  const unAnswerIndex = wordList.value.findIndex((w) => !w?.isAnswer);
  if (unAnswerIndex !== -1) {
    pckerIndex.value = [wordList.value[unAnswerIndex]?.wordId];
    changePickerValue(wordList.value[unAnswerIndex]);
  }
  pageAudioUrl.value = audioChange;
  playAudio("page");
  // 判断wordList 是否是全部答完 用isAnswer 判断
  if (isAllAnswer()) {
    // 全部答完，可在这里做结束处理
    submitAnswer();
  }
}
// 是否全部答完
function isAllAnswer() {
  return wordList.value.every((w) => w?.isAnswer);
}
// 提交答题
const isSubmitting = ref(false);
const submitAnswer = async () => {
  // 防止重复提交
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  
  const wrodParams = rawData.value.map((item) => {
    const matched = wordList.value.find((w) => w.wordId === item.wordId);
    return {
      ...item,
      submitContext:
        matched && matched.userAnswer !== undefined ? [matched.userAnswer] : [],
    };
  });
  const params = {
    courseBookId: curBookInfo.value.bookId,
    frameworkIds: [curBookInfo.value.frameworkId],
    questions: wrodParams,
  };
  console.log(params, "params");
  let api =
    roundNum.value === 1
      ? saveFirstRoundWordMeaning
      : roundNum.value === 2
      ? saveSecondRoundWordMeaning
      : saveThirdRoundWordMeaning;
  api(params).then((res) => {
    isSubmitting.value = false;
    if (res.code === 200) {
      closeAllAudio();
      router.push({
        path: "/wordTestData/index",
        query: {
          bookId: curBookInfo.value.bookId,
          frameworkId: curBookInfo.value.frameworkId,
        },
      });
    }
  }).catch(() => {
    isSubmitting.value = false;
  });
};
const audioRef = ref(null);
const pageAudioUrl = ref(null);
// 播放状态
const isPlaying = ref(false);
// 人物动画帧相关
const currentFrameIndex = ref(0);
let frameAnimationTimer = null;
let lastFrameTime = 0;
let isAnimating = false; // 动画运行标志
const FRAME_DURATION = 40; // 每帧40ms，约25fps，更流畅
// 计算当前帧的图片路径
const currentFrameSrc = computed(() => {
  return peopleFrames[currentFrameIndex.value] || peopleFrames[0];
});
// 预加载所有图片
function preloadImages() {
  peopleFrames.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}
// 启动动画
function startFrameAnimation() {
  // 先停止之前的动画
  stopFrameAnimation();
  // 重置到第一帧
  currentFrameIndex.value = 0;
  lastFrameTime = performance.now();
  isAnimating = true;

  // 使用 requestAnimationFrame 实现更流畅的动画
  function animateFrame(currentTime) {
    if (!isAnimating) return; // 如果动画已停止，退出

    const elapsed = currentTime - lastFrameTime;

    if (elapsed >= FRAME_DURATION) {
      currentFrameIndex.value =
        (currentFrameIndex.value + 1) % peopleFrames.length;
      lastFrameTime = currentTime;
    }

    frameAnimationTimer = requestAnimationFrame(animateFrame);
  }

  frameAnimationTimer = requestAnimationFrame(animateFrame);
}
// 停止动画
function stopFrameAnimation() {
  isAnimating = false;
  if (frameAnimationTimer) {
    cancelAnimationFrame(frameAnimationTimer);
    frameAnimationTimer = null;
  }
  // 重置到第一帧
  currentFrameIndex.value = 0;
  lastFrameTime = 0;
}
// 音频播放结束事件处理函数
let audioEndedHandler = null;
// 音频加载事件处理函数（用于在退出时移除）
let audioCanPlayHandler = null;
let audioLoadedDataHandler = null;
let audioErrorHandler = null;
// 标记是否应该播放音频（用于在退出时取消播放）
let shouldPlayAudio = true;
function playAudio(type = "topic") {
  if (!audioRef.value) return;

  const audioUrl =
    type === "topic"
      ? selectedWord.value?.wordInfo?.audioUrl
      : pageAudioUrl.value;

  // 检查音频源是否存在
  if (!audioUrl) {
    console.warn("音频源不存在:", type);
    return;
  }

  // 先停止当前播放
  audioRef.value.pause();
  audioRef.value.currentTime = 0;

  // 移除所有旧的事件监听器
  if (audioEndedHandler) {
    audioRef.value.removeEventListener("ended", audioEndedHandler);
    audioEndedHandler = null;
  }
  if (audioCanPlayHandler) {
    audioRef.value.removeEventListener("canplaythrough", audioCanPlayHandler);
    audioRef.value.removeEventListener("loadeddata", audioLoadedDataHandler);
    audioRef.value.removeEventListener("error", audioErrorHandler);
    audioCanPlayHandler = null;
    audioLoadedDataHandler = null;
    audioErrorHandler = null;
  }

  // 设置新的音频源
  audioRef.value.src = audioUrl;

  // 重置播放标志
  shouldPlayAudio = true;

  // 创建新的结束事件处理函数
  audioEndedHandler = () => {
    isPlaying.value = false;
    // 音频播放完毕，停止动画
    stopFrameAnimation();
  };
  audioRef.value.addEventListener("ended", audioEndedHandler);

  // 等待音频加载完成后再播放
  audioCanPlayHandler = () => {
    // 检查是否应该播放（可能在加载过程中已经退出）
    if (!shouldPlayAudio) {
      audioRef.value.removeEventListener("canplaythrough", audioCanPlayHandler);
      audioRef.value.removeEventListener("loadeddata", audioLoadedDataHandler);
      audioRef.value.removeEventListener("error", audioErrorHandler);
      return;
    }

    audioRef.value.removeEventListener("canplaythrough", audioCanPlayHandler);
    audioRef.value.removeEventListener("loadeddata", audioLoadedDataHandler);
    audioRef.value.removeEventListener("error", audioErrorHandler);

    // 再次检查是否应该播放
    if (!shouldPlayAudio) return;

    // 播放音频
    audioRef.value
      .play()
      .then(() => {
        // 音频开始播放时启动动画
        startFrameAnimation();
      })
      .catch((err) => {
        console.error("播放音频失败:", err);
        isPlaying.value = false;
        stopFrameAnimation();
      });
  };

  audioLoadedDataHandler = audioCanPlayHandler;

  // 错误处理
  audioErrorHandler = () => {
    audioRef.value.removeEventListener("canplaythrough", audioCanPlayHandler);
    audioRef.value.removeEventListener("loadeddata", audioLoadedDataHandler);
    audioRef.value.removeEventListener("error", audioErrorHandler);
    console.error("音频加载失败:", audioUrl);
    isPlaying.value = false;
    audioCanPlayHandler = null;
    audioLoadedDataHandler = null;
    audioErrorHandler = null;
  };

  // 监听加载完成事件
  audioRef.value.addEventListener("canplaythrough", audioCanPlayHandler);
  audioRef.value.addEventListener("loadeddata", audioLoadedDataHandler);
  audioRef.value.addEventListener("error", audioErrorHandler);

  // 开始加载
  audioRef.value.load();

  if (type === "topic") {
    isPlaying.value = true;
  }
}
// 关闭所有音频
function closeAllAudio() {
  if (!audioRef.value) return;

  // 设置标志，阻止任何待播放的音频
  shouldPlayAudio = false;

  audioRef.value.pause();
  audioRef.value.currentTime = 0;
  isPlaying.value = false;
  // 停止动画
  stopFrameAnimation();

  // 停止倒计时音频
  if (countdownAudioRef.value) {
    countdownAudioRef.value.pause();
    countdownAudioRef.value.currentTime = 0;
  }

  // 移除所有事件监听器
  if (audioEndedHandler) {
    audioRef.value.removeEventListener("ended", audioEndedHandler);
    audioEndedHandler = null;
  }

  if (audioCanPlayHandler) {
    audioRef.value.removeEventListener("canplaythrough", audioCanPlayHandler);
    audioRef.value.removeEventListener("loadeddata", audioLoadedDataHandler);
    audioRef.value.removeEventListener("error", audioErrorHandler);
    audioCanPlayHandler = null;
    audioLoadedDataHandler = null;
    audioErrorHandler = null;
  }

  try {
    audioRef.value.src = "";
    audioRef.value.load?.();
  } catch (e) {
    // ignore
  }
}
// 返回按钮点击事件
const handleBackClick = () => {
  // 清除定时器
  clearInterval(answerCountdownTimer);
  clearInterval(timer);
  closeAllAudio();
  const quitRequest = JSON.stringify({
    func: "getDialogDismiss",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
};
const isFirst = ref(true);
const token = ref("");
const curBookInfo = ref({});
function callJS(data) {
  let parsed;
  try {
    parsed = typeof data === "string" ? JSON.parse(data) : data;
  } catch (error) {
    console.error("callJS 解析失败:", error);
    return;
  }

  const { func, params } = parsed;

  // 如果是 getToken 或 getPageUrl，全局 callJS 已经处理了，这里不重复处理
  if (func === "getToken" || func === "getPageUrl") {
    return;
  }

  // 处理页面特定的逻辑
  if (func == "getBookInfo") {
    curBookInfo.value = params;
    isFirstRoundStart();
    isFirst.value = false;
  }
  if (func === "refresh") {
    console.log("🔄 收到刷新消息，重新加载数据");
    // 如果需要刷新数据，可以在这里添加逻辑
  }
  if (func === "actOnDestroy") {
    // 收到销毁事件，关闭所有音频并清理资源
    console.log("🔄 收到 actOnDestroy 事件，开始清理所有资源...");

    // 关闭所有音频（会移除所有事件监听器）
    closeAllAudio();

    // 清理定时器
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (answerCountdownTimer) {
      clearInterval(answerCountdownTimer);
      answerCountdownTimer = null;
    }
    // 停止动画
    stopFrameAnimation();

    // 清空所有变量和状态
    wordList.value = [];
    isStart.value = false;
    isCountdownEnd.value = false;
    countdownTime.value = 3;
    answerCountdownTime.value = 0;
    isAnswerCountdownEnd.value = false;
    progressWidth.value = 0;
    currentWordIndex.value = 0;
    selectedWord.value = {};
    curBtnType.value = "";
    showBtnImg.value = false;
    pckerIndex.value = [];
    isScrolling.value = false;
    pageAudioUrl.value = null;
    isPlaying.value = false;
    loading.value = true;
    rawData.value = [];
    roundNum.value = 1;
    isReport.value = true;

    console.log("✅ 所有资源已清理完成，页面状态已重置");
  }
}

// 调用原生 getShowBg 函数
function getShowBg() {
  const getShowBgRequest = JSON.stringify({
    func: "getShowBg",
    params: {
      fromType: 0,
    },
  });
  if (window.android) {
    window.android.callNative(getShowBgRequest);
  }
}
function goToken() {
  // 先调用全局 getToken（如果存在），确保 token 和 host 已获取
  if (window.getToken) {
    window.getToken();
  }

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
  }

  // 只请求页面特定的数据
  const getBookInfo = JSON.stringify({
    func: "getBookInfo",
  });
  if (window.android && isFirst.value) {
    window.android.callNative(getBookInfo);
  }
}
const loading = ref(true);
const rawData = ref([]); // 获取单词 提交时需要原封不动的数据
async function getRoundWords() {
  loading.value = true;
  let api =
    roundNum.value === 1
      ? getFirstRoundWords
      : roundNum.value === 2
      ? getSecondRoundWords
      : getThirdRoundWords;
  const res = await api({
    bookId: curBookInfo.value.bookId,
    frameworkId: curBookInfo.value.frameworkId,
  });
  // 处理返回数据
  if (res.code === 200) {
    wordList.value = res.data;
    loading.value = false;
    rawData.value = res.data;
    wordList.value.forEach((item) => {
      item.isAnswer = false;
      item.isRight = "";
      item.name = item.wordInfo.name;
      item.answerTime = 5;
      // item.randomTranslate = item.wordInfo.translate
    });
    selectedWord.value = wordList.value[0];
    answerCountdownTime.value = wordList.value[0]?.answerTime;
  }
}
const roundNum = ref(1);
// 判断是否开始第一轮
/**
 * 快速问答关卡状态 -1不需要 0未开始 1第一轮已完成 2第二轮已完成 3第三轮已完成
 */
const isReport = ref(true);
function isFirstRoundStart() {
  console.log(
    curBookInfo.value.quickQuizStatus,
    "curBookInfo.value.quickQuizStatus：快速问答关卡状态"
  );
  // 清除定时器
  clearInterval(answerCountdownTimer);
  clearInterval(timer);
  let currentRound = route.query?.sourceType || "";
  if (curBookInfo.value.quickQuizStatus == 0 && !currentRound) {
    //跳转到第一轮答题
    isReport.value = false;
    roundNum.value = 1;
    pageAudioUrl.value = audioOne;
    console.log(pageAudioUrl.value, "pageAudioUrl.value");
    // 播放当前音频
    nextTick(() => {
      playAudio("page");
    });
    getRoundWords();
  } else {
    // sourceType: 3=第一阶段, 4=第二阶段, 5=第三阶段
    // 需要转换为 round: 1=第一轮, 2=第二轮, 3=第三轮
  

	// eslint-disable-next-line no-unused-vars
    // console.log(sourceType, "sourceType",9999);
    // let currentRound = "";
    // if (sourceType == "3") {
    //   currentRound = "1"; // 第一阶段 -> 第一轮
    // } else if (sourceType == "4") {
    //   currentRound = "2"; // 第二阶段 -> 第二轮
    // } else if (sourceType == "5") {
    //   currentRound = "3"; // 第三阶段 -> 第三轮
    // }

    if (["1", "2", "3"].includes(currentRound)) {
      roundNum.value = Number(currentRound);
      console.log(
        roundNum.value,
        "roundNum.value：第几轮，sourceType:",
        currentRound
      );
      pageAudioUrl.value =
        currentRound === "1"
          ? audioOne
          : currentRound === "2"
          ? audioTwo
          : audioThree;
      isReport.value = false;
      // 播放当前音频
      nextTick(() => {
        playAudio("page");
      });
      getRoundWords();
      return;
    }
    router.push({
      path: "/wordTestData/index",
      query: {
        bookId: curBookInfo.value.bookId,
        frameworkId: curBookInfo.value.frameworkId,
      },
    });
  }
}

// 禁用 Picker 滚动
function disablePickerScroll() {
  nextTick(() => {
    const pickerElement = myPicker.value?.$el;
    if (!pickerElement) return;

    // 查找所有可滚动的元素
    const scrollableElements = pickerElement.querySelectorAll(
      ".van-picker-column__wrapper, .van-picker-column"
    );

    // 记录触摸开始时的位置和目标
    let touchStartInfo = null;

    const preventScroll = (e) => {
      // 如果正在自动滚动，阻止所有手动滚动（除了音频按钮的点击）
      if (isScrolling.value) {
        const hornButton = e.target.closest(".horn");
        const phoneticSymbols = e.target.closest(".word-phoneticSymbols");
        // 如果是音频按钮的点击事件，允许
        if (
          (hornButton || phoneticSymbols) &&
          (e.type === "touchstart" || e.type === "mousedown")
        ) {
          return true;
        }
        // 其他所有事件都阻止
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // 检查是否是音频播放按钮或其父元素
      const hornButton = e.target.closest(".horn");
      const phoneticSymbols = e.target.closest(".word-phoneticSymbols");
      const isHornRelated = hornButton || phoneticSymbols;

      // 如果是音频按钮相关元素，根据事件类型处理
      if (isHornRelated) {
        // touchstart/mousedown: 记录起始位置，允许点击但不阻止事件
        if (e.type === "touchstart" || e.type === "mousedown") {
          const touch = e.touches ? e.touches[0] : e;
          touchStartInfo = {
            target: e.target,
            x: touch.clientX,
            y: touch.clientY,
            time: Date.now(),
          };
          return true; // 允许事件继续，不阻止
        }

        // touchmove/mousemove: 如果是从音频按钮开始的拖动，阻止滚动
        if (e.type === "touchmove" || e.type === "mousemove") {
          if (touchStartInfo) {
            const touch = e.touches ? e.touches[0] : e;
            const deltaX = Math.abs(touch.clientX - touchStartInfo.x);
            const deltaY = Math.abs(touch.clientY - touchStartInfo.y);
            // 如果移动距离超过阈值（5px），认为是拖动，阻止滚动
            if (deltaX > 5 || deltaY > 5) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
          return true;
        }

        // touchend/mouseup/touchcancel: 清除记录，允许点击完成
        if (
          e.type === "touchend" ||
          e.type === "touchcancel" ||
          e.type === "mouseup"
        ) {
          touchStartInfo = null;
          return true; // 允许点击事件完成
        }

        return true;
      }

      // 对于其他元素，清除记录（如果有）
      if (
        e.type === "touchend" ||
        e.type === "mouseup" ||
        e.type === "touchcancel"
      ) {
        touchStartInfo = null;
      }

      // 对于其他元素，阻止所有滚动
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    scrollableElements.forEach((el) => {
      // 阻止触摸事件
      el.addEventListener("touchstart", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("touchmove", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("touchend", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("touchcancel", preventScroll, {
        passive: false,
        capture: true,
      });
      // 阻止鼠标事件
      el.addEventListener("mousedown", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("mousemove", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("mouseup", preventScroll, {
        passive: false,
        capture: true,
      });
      // 阻止滚轮事件
      el.addEventListener("wheel", preventScroll, {
        passive: false,
        capture: true,
      });
      el.addEventListener("scroll", preventScroll, {
        passive: false,
        capture: true,
      });
    });
  });
}

onMounted(() => {
  // 预加载所有图片帧，提升动画流畅度
  preloadImages();

  // 保存原有的 callJS（全局的）
  const originalCallJS = window.callJS;
  window.callJS = (data) => {
    // 先调用全局 callJS（处理 getToken 和 getPageUrl）
    if (originalCallJS) {
      originalCallJS(data);
    }
    // 然后调用页面特定的 callJS（只处理页面特定的逻辑，getToken 和 getPageUrl 会被跳过）
    callJS(data);
  };

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
  }

  // 请求页面特定的数据（会先调用全局 getToken）
  goToken();
  // 调用 getShowBg
  getShowBg();

  // 监听 isCountdownEnd 和 isStart，当 Picker 显示时禁用滚动
  watch(
    [isCountdownEnd, isStart],
    () => {
      if (isCountdownEnd.value && isStart.value) {
        setTimeout(() => {
          disablePickerScroll();
        }, 100);
      }
    },
    { immediate: true }
  );

  // 初始禁用滚动
  setTimeout(() => {
    disablePickerScroll();
  }, 500);
});

onBeforeUnmount(() => {
  // 清理所有定时器
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  if (answerCountdownTimer) {
    clearInterval(answerCountdownTimer);
    answerCountdownTimer = null;
  }
  // 停止动画
  stopFrameAnimation();
  // 关闭所有音频
  closeAllAudio();
  // 清理倒计时音频
  if (countdownAudioRef.value) {
    countdownAudioRef.value.pause();
    countdownAudioRef.value.src = "";
    countdownAudioRef.value = null;
  }
});
</script>
<style scoped lang="scss">
.page {
  width: 960px;
  height: 600px; // 固定高度，基于 960x600 设计稿
  .container {
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.5);
    background: transparent;
    padding: 41px 0 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .header {
      padding: 0 20px; // 内容区域保持左右 padding
      .back {
        position: relative;
        z-index: 20000;
        width: 39px;
        height: 39px;
      }
    }
    .content {
      padding: 0 20px; // 内容区域保持左右 padding
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .ip-layout {
        position: relative;
        width: 163px;
        height: 302px;
        margin-left: 20px;
        .ip-icon {
          position: absolute;
          left: -50px;
          width: 167px * 1.4;
          height: 226px * 1.4;
          will-change: contents;
          backface-visibility: hidden;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          -moz-transform: translateZ(0);
          -ms-transform: translateZ(0);
          -o-transform: translateZ(0);
        }
      }
      .word-content-wrap {
        flex: 1;
        margin-left: 20px;
        position: relative;
        margin-bottom: 20px;
        .word-btns-wrap {
          position: absolute;
          bottom: 30px;
          right: 50%;
          transform: translateX(50%);
          z-index: 20000;
          .btn-img {
            width: 125px;
            height: 36px;
          }
          .word-btn {
            display: flex;
            gap: 40px;
            .word-btn-item {
              position: relative;
              z-index: 20001;
              width: 108px;
              height: 44px;
              border-radius: 44px;
              background: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 15px;
              color: #666666;
              pointer-events: auto;
              &.active {
                background: #a07dff;
                color: #fff;
              }
            }
          }
        }
        &.active {
          .word-content-border {
            background-image: url("@/assets/quick/bg-2.png");
            background-size: cover;
          }
        }
        .word-content-border {
          width: 683px;
          height: 419px;
          padding: 10px;
          background-image: url("@/assets/quick/bg-1.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .word-content {
            width: 100%;
            height: 100%;
            border-radius: 24px;
            padding: 12px;
            box-sizing: border-box;
            .word-picker-wrap {
              .haader {
                display: flex;
                justify-content: space-between;
                .left {
                  display: flex;
                  align-items: center;
                  flex-shrink: 0; /* 防止被挤压 */
                  span {
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    white-space: nowrap; /* 文字不换行，避免挤压变形 */
                  }
                  .word-num {
                    font-size: 13px;
                    color: #bbbbbb;
                    margin-left: 10px;
                    & > span:first-child {
                      color: #a68afe;
                      margin: 0px 2px;
                      font-size: 13px;
                    }
                    & > span:last-child {
                      font-size: 13px;
                      color: #adabb2;
                    }
                  }
                }
                .right {
                  background: #f6f6f6;
                  border-radius: 36px 36px 36px 36px;
                  border: 1px solid #ffffff;
                  font-size: 15px;
                  color: #333333;
                  width: 80px;
                  height: 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  img {
                    width: 18px;
                    height: 18px;
                    margin-right: 10px;
                  }
                }
              }
            }
            .countdown-content {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
              img {
                width: 68px;
                height: 130px;
              }
            }
            .word-content-start {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              font-size: 24px;
              font-weight: bold;
              color: #333333;
              .l {
                width: 14px;
                height: 15px;
                margin-right: 4px;
              }
              .r {
                width: 14px;
                height: 15px;
                margin-left: 4px;
              }
              .round {
                font-weight: 400;
                font-size: 18px;
                margin: 10px 0;
              }
              .start-btn {
                width: 190px;
                height: 52px;
                border-radius: 28px;
                text-align: center;
                line-height: 52px;
                margin-top: 10px;
                background: linear-gradient(
                  81deg,
                  rgba(160, 125, 255, 1) 0%,
                  /* 起始色：浅紫蓝 */ rgba(196, 175, 255, 1) 100%
                    /* 结束色：更浅的淡紫色 */
                );
                font-weight: bold;
                font-size: 18px;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
}
/* 进度条样式 */
.progress-bar-container {
  width: 134px;
  height: 10px;
  border: 2px solid #eee;
  border-radius: 11px;
  box-sizing: border-box;
  margin-left: 10px;
  position: relative;
}

.progress-bar {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6; /* 浅灰色背景 */
  border-radius: 4px;
}

.progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #a07fff, #8a5fff); /* 紫色渐变 */
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-dot {
  position: absolute;
  top: -4px;
  left: 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-image: url("@/assets/quick/circle.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transform: translateX(-50%); /* 让圆点居中于左侧 */
  transition: left 0.3s ease;
}
:deep(.van-picker) {
  background: transparent;
  .custom-picker-item.active {
    .word-en {
      font-weight: bold;
      font-size: 42px;
      color: #333333;
      .is-right {
        display: block;
      }
      .translate {
        color: #666;
      }
    }
    .is-right-box.right {
      color: #49c476;
    }
    .is-right-box.error {
      color: #ff8787;
    }
    .word-phoneticSymbols {
      display: flex !important;
      & > div.play {
        .play-1 {
          animation: hornWave1 1.2s infinite ease-out;
        }
        .play-2 {
          animation: hornWave2 1.2s infinite ease-out 0.6s;
        }
      }
    }
  }
  .is-right {
    width: 27px;
    height: 27px;
  }
  .custom-picker-item {
    font-size: 24px;
    font-weight: 400;
    color: #bbbbbb;
    display: flex;
    align-items: center;
    flex-direction: column;
    .word-en {
      display: flex;
      align-items: center;
    }
    .translate {
      font-size: 13px;
      color: #bbbbbb;
      display: inline-block;
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-left: 10px;
      margin-right: 5px;
    }
    .is-right-box {
      font-size: 13px;
      display: flex;
      align-items: center;
      .word-translate {
        max-width: 441px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .word-phoneticSymbols {
      font-size: 15px;
      display: flex;
      align-items: center;
      margin: 5px 0;
      position: relative;
      z-index: 20001;
      pointer-events: auto;
      & > div {
        display: flex;
        align-items: center;
        pointer-events: auto;
      }
      .horn {
        position: relative;
        width: 12px;
        height: 14px;
        margin-left: 4px;
        z-index: 20002;
        pointer-events: auto;
        cursor: pointer;
      }
      .play-1,
      .play-2 {
        transform-origin: bottom;
      }
      .play-1 {
        width: 3px;
        height: 8px;
        margin-left: 2px;
        animation-delay: 0s;
      }
      .play-2 {
        width: 4px;
        height: 12px;
        animation-delay: 0.2s;
      }
      @keyframes hornWave1 {
        0% {
          // transform: translate(-50%, -50%) scale(0.8);
          opacity: 1;
        }
        100% {
          // transform: translate(-50%, -50%) scale(2);
          opacity: 0;
        }
      }

      // 声波2动画关键帧：更大范围缩放
      @keyframes hornWave2 {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
  }
  .van-hairline-unset--top-bottom:after {
    border-color: rgba(159, 159, 159, 0.3);
  }
}
:deep(.van-picker__mask) {
  background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0.4)
    ),
    linear-gradient(
      to top,
      rgba(235, 225, 250, 0.7),
      rgba(235, 225, 250, 0) 60%
    );
}
:deep(.van-hairline-unset--top-bottom) {
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100% !important;
    height: 1px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      #9f9f9f 48%,
      #ffffff 100%,
      #000000 100%
    );
    border: none;
    transform: none;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      270deg,
      #ffffff 0%,
      #9f9f9f 48%,
      #ffffff 100%,
      #000000 100%
    );
  }
}
:deep(.van-picker__loading) {
  color: #a07dff;
}
:deep(.custom-word-picker) {
  touch-action: none !important;
  overflow: hidden !important;
  overscroll-behavior: none !important;
}
:deep(.custom-word-picker .van-picker-column) {
  touch-action: none !important;
  overflow: hidden !important;
  overscroll-behavior: none !important;
}
:deep(.custom-word-picker .van-picker-column__wrapper) {
  touch-action: none !important;
  overflow: hidden !important;
  overscroll-behavior: none !important;
}
.custom-word-picker :deep(.horn) {
  pointer-events: auto !important;
  z-index: 20002 !important;
  position: relative !important;
  cursor: pointer !important;
}

.custom-word-picker :deep(.word-phoneticSymbols) {
  pointer-events: auto !important;
  z-index: 20001 !important;
  position: relative !important;
}

.custom-word-picker :deep(.word-phoneticSymbols > div) {
  pointer-events: auto !important;
}
</style>
